import { defineStore } from 'pinia';

interface SettingsState {
  darkMode: boolean;
  locale: string;
}

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsState => ({
    darkMode: false,
    locale: 'en',
  }),

  actions: {
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      document.body.classList.toggle('dark', this.darkMode);
    },
  },

  persist: true,
});
